module.exports = __webpack_public_path__ + "img/blue-blur.d212fc69.svg";